module.exports = __webpack_public_path__ + "img/3.8b41f960.png";